import ViewerContainer from '@components/Chat/ChatMenu/Viewer/ViewerContainer';

const Viewer = () => {
  const searchPrams = new URLSearchParams(window.location.search);
  const rfqId = searchPrams.get('rfqId') || '';
  const chatRoomId = searchPrams.get('chatRoomId') || '';

  return (
    <ViewerContainer
      mode={chatRoomId ? 'chat' : 'default'}
      rfqId={rfqId}
      chatRoomId={chatRoomId}
    />
  );
};

export default Viewer;
